<template>
  <div>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li v-for="(item, index) in reservations.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
      </ul>
    </nav>
    <b-table small
      :fields="tableHead"
      :items="reservations.data"
      responsive="sm"
    >
      <!-- A custom formatted column -->
      <template #cell(created_at)="data">
        {{ $moment(data.item.created_at).format('HH:mm') }}
      </template>
      <!-- A custom formatted column -->
      <template #cell(total)="data">
        {{ numberFormat(data.item.total) }} {{ data.item.currency }}
      </template>
      <template #cell(base_total)="data">
        {{ numberFormat(data.item.base_total) }} {{ data.item.currency }}
      </template>
      <template #cell(commission)="data">
        {{ numberFormat(data.item.total - data.item.base_total) }} {{ data.item.currency }}
      </template>
      <template #cell(status)="data">
        <b-badge v-if="data.item.status == 'completed'" variant="success">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'cancelled'" variant="danger">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'in_process'" variant="info">{{data.item.status}}</b-badge>
        <b-badge v-if="data.item.status == 'pending'" variant="light">{{data.item.status}}</b-badge>
      </template>
      <template #cell(options)="data">
        <b-button size="sm" :href="urlReservation(data.item)" variant="outline-primary">
          <font-awesome-icon :icon="['fas', 'edit']"/>
        </b-button>
        <b-button size="sm" :href="urlPrintReservation(data.item)" target="_blank" variant="primary">
          <font-awesome-icon :icon="['fas', 'print']"/>
        </b-button>
        <b-button v-if="data.item.status !== 'cancelled'" v-b-tooltip.hover size="sm" target="_blank" variant="danger" title="Cancelar" @click="confirmCancel(data)">
          <font-awesome-icon :icon="['fas', 'times-circle']"/>
        </b-button>
      </template>
    </b-table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li v-for="(item, index) in reservations.links" :key="index" :class="(item.active ? 'active' : '' )+ ' page-item'"><a class="page-link" :href="item.url" v-html="item.label"></a></li>
      </ul>
    </nav>
    <b-modal
      id="bv-modal-confirm-cancel"
      header-bg-variant="danger"
      header-text-variant="light"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer>
      <Loading :active="loading" :full-page="false"></Loading>
      <template #modal-title>
        Confirme que desea cancelar la reservación {{ selectedReservation.item.code }}
      </template>
      <div class="row">
        <div class="col-sm-6">
          <b-button class="mt-3" block variant="danger" @click="cancelReservation">Confirmar Cancelación</b-button>
        </div>
        <div class="col-sm-6">
          <b-button class="mt-3" block variant="light" @click="$bvModal.hide('bv-modal-confirm-cancel')">Cerrar</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import {NumberFormat} from "../../helpers/NumberFormat"
  export default {
    name: 'ReservationsSupervisor',
    props:['reservations'],
    components: {FontAwesomeIcon},
    data() {
      return {
        loading:false,
        tableHead: [
          { key: 'id', label: 'ID' },
          { key: 'created_at', label: 'Hora' },
          { key: 'customer_name', label: 'Cliente' },
          { key: 'status', label: 'Status' },
          { key: 'service_type', label: 'Servicio' },
          { key: 'service_name', label: 'Producto' },
          { key: 'pax', label: 'Pax' },
          { key: 'total', label: 'Total' },
          { key: 'base_total', label: 'B.Total' },
          { key: 'quota', label: 'Cuota' },
          { key: 'commission', label: 'Comisión' },
          { key: 'payment_type', label: 'Pago' },
          { key: 'options', label: 'Acciones' },
        ]
      }
    },
    methods:{
      getCommission(reservation) {
        return parseFloat(reservation.total) - (parseFloat(reservation.base_total) + parseFloat(reservation.quota))
      },
      numberFormat(num) {       
        let n = num || 0 
        return NumberFormat.format(parseFloat(n), 2, ',', '.')
      },
      urlReservation(item) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id
      },
      urlPrintReservation(item) {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations`
        return url+'/'+item.id+'/print-ticket'
      },
      confirmCancel(data) {
        this.selectedReservation = data
        this.$bvModal.show('bv-modal-confirm-cancel')
      },
      cancelReservation() {
        const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations/${this.selectedReservation.item.id}/cancel`
        this.loading = true
        this.$axios.post(url, {id:this.selectedReservation.item.id}).then(rs => {
          //this.$store.dispatch('quote/setData', rs.data)
          this.reservations[this.selectedReservation.index].status = 'cancelled'
          this.$bvModal.hide('bv-modal-confirm-cancel')
          this.loading = false
          /*if (!rs.data.error) {
          } else {
            this.loading = false
          }*/
        })
        .catch(error=> {
          if (error.response) {
            this.errors = error.response.data.errors
          }  else {
            this.errors = {
              unexpected: ['Hubo un error por favor contacte al administrador']
            }
          }
          console.log('error quote', error);
          this.loading = false
        })
      }
    }
  }
</script>